import React from 'react';
import {
  Container,
  Flex,
  Link,
  ListItem,
  Text,
  UnorderedList,
} from '@chakra-ui/react';
import type { NextPage } from 'next';
import Layout from '@/components/Layout';

const DisclaimerInfoText = [
  {
    id: 1,
    label:
      ' Does not constitute personal securities recommendations orinvestment advice',
  },
  {
    id: 2,
    label: ' Should not be relied upon as professional financial advice',
  },
  {
    id: 3,
    label:
      ' Is not intended to be a substitute for advice from a qualified financial investment adviser',
  },
  {
    id: 4,
    label:
      'IVCA does not warrant, guarantee or represent the completeness or accuracy of any information provided by IVCA and does not assume or accept any liability or responsibility for:',
  },
  {
    id: 5,
    label:
      '  The accuracy of any information provided on this site, whether from the passing of time or otherwise',
  },
  {
    id: 6,
    label: 'Any errors or omissions in any information provided',
  },
  {
    id: 7,
    label:
      ' Any loss or damage suffered in any way by any person relying on any information provided',
  },
];

const Disclaimer: NextPage = () => (
  <Layout
    title="Disclaimer"
    url="disclaimer"
    description="IVCA's website is the virtual hub for the Indian Private Equity & Venture Capital industry. Its aim is to link companies and organizations that are involved in the provision of Private Equity (PE), Venture Capital (VC) and professional services to the Indian PE/VC industry."
  >
    <Flex
      flexDir="column"
      backgroundImage="linear-gradient(#F7F7FB 0 50%, #E2E2E2 50% 100%)"
      pb="50px"
    >
      <Text variant="headingText" textAlign="center" py="50px">
        Disclaimer
      </Text>
      <Container maxW="1325px">
        <Flex
          flexDir="column"
          bg="white"
          py="80px"
          px="50px"
          boxShadow="lg"
          borderRadius="8px"
        >
          <Text variant="aboutText" textAlign="justify">
            IVCA&apos;s website is the virtual hub for the Indian Private Equity
            & Venture Capital industry. Its aim is to link companies and
            organizations that are involved in the provision of Private Equity
            (PE), Venture Capital (VC) and professional services to the Indian
            PE/VC industry.
          </Text>
          <Flex flexDir="column">
            <Text
              pt="60px"
              pb="10px"
              variant="headingText"
              fontWeight="semibold"
              fontSize="1.5rem"
            >
              IVCA does not:
            </Text>
            <UnorderedList pl="20px" textAlign="justify">
              <ListItem fontSize="1.15rem" color="text.darkHead">
                Give investment advice
              </ListItem>
              <ListItem fontSize="1.15rem" color="text.darkHead">
                Carry on an investment advisory business
              </ListItem>
            </UnorderedList>
          </Flex>

          <Flex flexDir="column">
            <Text
              pt="60px"
              pb="10px"
              variant="headingText"
              fontWeight="semibold"
              fontSize="1.5rem"
            >
              Information provided on IVCA website:
            </Text>
            <UnorderedList pl="20px" textAlign="justify">
              {DisclaimerInfoText.map((info) => (
                <ListItem
                  fontSize="1.15rem"
                  color="text.darkHead"
                  key={info.id}
                >
                  {info.label}
                </ListItem>
              ))}
            </UnorderedList>
            <Text variant="aboutText" pt="30px">
              IVCA assumes no liability for the actions of its members or any
              other person referred to on this site. Any links to other web
              sites or other contact details do not constitute endorsement of
              any materials, organization, product or service.
            </Text>
          </Flex>

          <Flex flexDir="column">
            <Text
              pt="60px"
              pb="10px"
              variant="headingText"
              fontWeight="semibold"
              fontSize="1.5rem"
            >
              Grievances & Redressals:
            </Text>
            <UnorderedList pl="20px">
              <ListItem fontSize="1.15rem" color="text.darkHead">
                IVCA strives to create a world-best environment in India for
                private equity, venture capital and entrepreneurship. If you
                have a comment regarding the conduct of an investor member,
                please contact
              </ListItem>
            </UnorderedList>
            <Text variant="aboutText" pt="30px">
              Rajat Tandon, President at{' '}
              <Link href="/#" color="#18acd5">
                rajat.tandon@ivca.in
              </Link>
              <br />
              or Aakriti Bamniyal, Vice President at{' '}
              <Link href="/#" color="#18acd5">
                aakriti@ivca.in
              </Link>
            </Text>
          </Flex>
        </Flex>
      </Container>
    </Flex>
  </Layout>
);

export default Disclaimer;
